// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3tt9j","label":"CategoryService_label__2wyQh","location":"CategoryService_location__1aL5W"};